import { render, staticRenderFns } from "./article-card-list.vue?vue&type=template&id=30bdc7bf&scoped=true&"
import script from "./article-card-list.vue?vue&type=script&lang=js&"
export * from "./article-card-list.vue?vue&type=script&lang=js&"
import style0 from "./article-card-list.vue?vue&type=style&index=0&id=30bdc7bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bdc7bf",
  null
  
)

export default component.exports